<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Menu</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Options</h2>

    <h3>Text button - for example for languages</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-menu
        label="English (US)"
        [icon]="'translate'"
        [menuItems]="menuItems"
        [textSize]="'smaller'"
        [type]="'text'">
      </ui-platform-menu>
    </div>

    <h3>Primary button with chevron</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-menu
        label="Menu"
        [chevron]="true"
        [menuItems]="menuItems"
        [type]="'primary'"></ui-platform-menu>
    </div>

    <h3>Lighter icon</h3>
    <p>Use Gray-3 for icon with lighterIcon parameter</p>
    <div class="button-row">
      <ui-platform-menu
        [icon]="'dots'"
        [lighterIcon]="true"
        [menuItems]="menuItems"
        [type]="'text'"></ui-platform-menu>
    </div>

    <h3>Link button with click trigger</h3>
    <p>Add type 'link' and dropdownTriggerType="click"</p>
    <div class="button-row">
      <ui-platform-menu
        dropdownTriggerType="click"
        label="Text link btn"
        [menuItems]="menuItems"
        [type]="'link'"></ui-platform-menu>
    </div>

    <h3>Nested menu</h3>
    <div class="button-row">
      <ui-platform-menu
        dropdownTriggerType="click"
        label="Link nested menu "
        [menuItems]="nestedItems"
        [type]="'link'"></ui-platform-menu>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Template usage</h2>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
    <p>Menu items for menu:</p>
    <pre>{{ menuItemsSample }}</pre>
  </div>
</div>
